const defaultTimeOut = 1000;

const getAnalyticsConfig = (config) => {
  if (config && typeof config === 'object' && !Array.isArray(config)) {
    return {
      dispatchImmediately: Boolean(config.dispatchImmediately),
      timeOut: config.timeOut ?? defaultTimeOut,
    };
  }

  return {
    dispatchImmediately: false,
    timeOut: config ?? defaultTimeOut,
  };
};

const queueAnalyticsEvent = (thdAnalyticsEvent) => {
  if (!window.digitalData) {
    window.digitalData = {};
  }

  if (!window.digitalData.event) {
    window.digitalData.event = [];
  }

  window.digitalData.event.push(thdAnalyticsEvent);
};

const dispatchAnalyticsEvent = (thdAnalyticsEvent, dispatchImmediately) => {
  if (dispatchImmediately && window._T && typeof window._T.sendEventDataToAnalytics === 'function') {
    try {
      window._T.sendEventDataToAnalytics(thdAnalyticsEvent);
      return;
    } catch (error) {
      queueAnalyticsEvent(thdAnalyticsEvent);
      return;
    }
  }

  queueAnalyticsEvent(thdAnalyticsEvent);
};

export class Analytics {
  static sendAnalyticsEvent = (thdAnalyticsEvent, config = defaultTimeOut) => new Promise((resolve) => {
    if (typeof window === 'undefined') {
      resolve();
      return;
    }

    const { dispatchImmediately, timeOut } = getAnalyticsConfig(config);

    dispatchAnalyticsEvent(thdAnalyticsEvent, dispatchImmediately);

    const delay = typeof timeOut === 'function' ? timeOut() : timeOut;
    const waitMs = Number.isFinite(delay) ? delay : defaultTimeOut;
    window.setTimeout(resolve, waitMs);
  });
}

const exportObj = {
  Analytics,
};

export default exportObj;
